import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import { environment } from "environments/environment";

import { SharedCommonService } from "app/shared/shared-common.service";
import { TokenStorageService } from "app/brightserve/token-storage.service";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()
export class SecurityService {
    private ClientId = "";

    constructor(private tokenStorage: TokenStorageService, private http: HttpClient) { }

    Login(Username: string, Password: string): Observable<any> {
        
        var headers = new HttpHeaders({ 'Content-Type': "application/x-www-form-urlencoded" });
        var data = "grant_type=password&username=" + Username + "&password=" + Password + "&client_id=" + environment.clientId;
        return this.http.post("/token", data, { headers: headers })
            .map((res: any) => this.SetLoginResult(res));
    };

    private SetLoginResult(res) {
        var result = res || {};
        var data = JSON.parse(result.Data);
        if (data != {} && result.Code == "999") {
            this.tokenStorage.setAccessToken(data.access_token);
            this.tokenStorage.setRefreshToken(data.refresh_token);
        }
        else {
            return Observable.throw(result.Message || 'Server error');
        }
        return result;
    };
}



// WEBPACK FOOTER //
// ./src/app/security/security.service.ts